import { render, staticRenderFns } from "./MenuManager.vue?vue&type=template&id=1b92623c&scoped=true&"
import script from "./MenuManager.vue?vue&type=script&lang=js&"
export * from "./MenuManager.vue?vue&type=script&lang=js&"
import style0 from "./MenuManager.vue?vue&type=style&index=0&id=1b92623c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b92623c",
  null
  
)

export default component.exports